import $ from "./jQuery-wrapper.js";

class CustomisedSmartPostShow
{
	constructor(el)
	{
		this.$element = $(el);

		this.replaceReadMoreButtons();
		this.putExcerptAndLinkAfterItem();
		this.correctTitlePosition();
		this.removeRedundantPostDetails();
	}

	replaceReadMoreButtons()
	{
		this.$element.find(".sp-pcp-readmore").each((index, el) => {

			const $replacement = $(`<div class="wp-block-buttons">
					<div class="wp-block-button light-bg-btn">
						<a class="wp-block-button__link has-ast-global-color-4-color has-text-color">
							<i class="fas fa-arrow-right"></i>
							<span class="btn-txt"></span>
						</a>
					</div>
				</div>
			`);

			const $link = $(el).find(".pcp-readmore-link");

			$replacement.find("a").attr("href", $link.attr("href"));
			$replacement.find(".btn-txt").text($link.text());

			$(el).replaceWith($replacement);

		});
	}

	putExcerptAndLinkAfterItem()
	{
		const $content = $(".sp-pcp-post-content");

		$content.each((index, el) => {

			$(el).closest(".sp-overlay").find(".pcp-post-thumb-wrapper").append(el);

		});
	}

	correctTitlePosition()
	{
		$("h2.sp-pcp-title").each((index, el) => {

			const $overlay = $(el).closest(".sp-overlay");
			const $title = $(el);

			$overlay.find(".sp-pcp-post-thumb-area").append($title);

		});
	}

	removeRedundantPostDetails()
	{
		$(".sp-pcp-post-details").remove();
	}
}

export default CustomisedSmartPostShow;